import { createSelector } from 'reselect';
import { getAllowedManageTeamTabs } from "../../guard/menuUtils";

export const selectModuleTabs = (module) =>
    createSelector(
        [(state) => state[module]],
        (moduleState = { defaultTabs: [], dynamicTabs: [], activeTab: 0 }) => {
            const allDefaultTabs = moduleState.defaultTabs || [];
            const dynamicTabs = moduleState.dynamicTabs || [];
            const allowedTabs = getAllowedManageTeamTabs(module);

            // Filter default tabs by privilege
            const filteredDefaultTabs = allowedTabs.length > 0
                ? allDefaultTabs.filter(tab => allowedTabs.includes(tab.name))
                : [];

            // Combine filtered default tabs and dynamic tabs
            const tabs = [...filteredDefaultTabs, ...dynamicTabs];
            // Ensure the active tab index is always within bounds of the visible tabs
            const resolvedActiveTab = Math.min(
                moduleState.activeTab,
                Math.max(tabs.length - 1, 0)
            );

            return {
                tabs,
                activeTab: resolvedActiveTab,
                defaultTabsCount: filteredDefaultTabs.length,
                selectedTemplate: moduleState.selectedTemplate,
            };
        }
    );
